/**
* Helper function to check if the device is a mobile device
* @returns {boolean} true if the device is a mobile device, false otherwise
*/

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}